/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Draw name" |
*
* @param {Raffle_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_name_label = /** @type {((inputs?: Raffle_Name_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Name_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du tirage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del sorteo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome do sorteio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome dell'estrazione")
	return /** @type {LocalizedString} */ ("Draw name")
});